import axios from "axios";

interface Activity {
  date: string;
  total_activities: string;
}

interface ExperienceData {
  user: string;
  activities: Activity[];
  experience: number;
}

export const getExperienceData = async (
  userId: string
): Promise<ExperienceData | undefined> => {
  try {
    const response = await axios.get<ExperienceData>(
      `https://chamstudyland.com/api/fun_learning/get_experience.php?id=${userId}`
    );
    return response.data;
  } catch (error) {
    console.log(error);
  }
};
